import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Provides access to the Sales KPI API.
 * */
@Injectable({ providedIn: 'root' })
export class SalesApiService {
  apiUrl = '/api';

  constructor(private http: HttpClient) {

  }

  getOverview(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/kpi/overview`);
  }

  getDetailsForLob(lobName: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/kpi/details/${lobName}`);
  }
}
